<template>
  <img :src="pathImage" alt="Lixeira" width="70px" height="70px" />
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import pathImage from '../../../assets/mapa-industrial-dinamico/lixeira.gif'

@Component({
  name: 'TrashIcon'
})
class TrashIcon extends Vue {
  pathImage = pathImage
}
export default TrashIcon
</script>
<style>

</style>
